import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "bottom" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_FeedHeader = _resolveComponent("FeedHeader")
  const _component_SourcesSection = _resolveComponent("SourcesSection")
  const _component_PulseActions = _resolveComponent("PulseActions")
  const _component_Segment = _resolveComponent("Segment")

  return (_openBlock(), _createBlock(_component_Segment, {
    class: _normalizeClass(["pulse-item", {active: $options.active_state, 'user-hover': $data.user_hover, pointer: !this.static}]),
    onMouseenter: $options.onMouseEnter,
    onMouseleave: $options.onMouseLeave,
    onClick: $options.onClick
  }, {
    default: _withCtx(() => [
      _createVNode(_component_FeedHeader, { item: $props.item }, null, 8 /* PROPS */, ["item"]),
      _createElementVNode("div", _hoisted_1, _toDisplayString($props.item.title), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_SourcesSection, {
          sources: $props.item.source_icon_urls,
          class: "pulse-sources",
          "view-count": _ctx.$responsive.desktop ? 4 : 2
        }, null, 8 /* PROPS */, ["sources", "view-count"]),
        (!this.static)
          ? (_openBlock(), _createBlock(_component_PulseActions, {
              key: 0,
              "pulse-item": $props.item,
              show: $data.user_hover || $options.active_state,
              size: _ctx.$responsive.mobile ? '1.6rem' : undefined,
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
              onShow: $options.handleFeedback
            }, null, 8 /* PROPS */, ["pulse-item", "show", "size", "onShow"]))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class", "onMouseenter", "onMouseleave", "onClick"]))
}